import * as React from 'react';
import { I18n } from 'react-redux-i18n';

import { InputWrapper, IconLink, ButtonAdd, Error } from './styles';
import ButtonRemove from '../ButtonRemove';
import LinkTypeToggle from './LinkTypeToggle';
import { LinkType } from '../../../../containers/Editor/constants';
import { getLinkType } from '../../../../containers/Editor/utils/helpers';
import Utils from '../../../../utils';

interface LinkPanelProps {
	value: string;
	totalPages: number;
	canAddLink?: boolean;
	isUrlLinkOnly?: boolean;
	onChange: (value: string) => void;
	onFocus?: () => void;
	onBlur?: () => void;
}

const isValidValue = (value: string, totalPages: number): { [k: string]: boolean } => ({
	url: Utils.isValidUrl(value),
	gotoPage: +value > 0 && +value <= totalPages,
});

const errorMessages: { [k: string]: string } = {
	url: 'error.invalid_url',
	gotoPage: 'error.invalid_page_number',
};

const LinkPanel = ({
	value,
	totalPages,
	canAddLink = true,
	isUrlLinkOnly,
	onChange,
	onFocus,
	onBlur,
}: LinkPanelProps) => {
	const [inputValue, setInputValue] = React.useState(value);
	const [isError, setIsError] = React.useState(false);
	const [type, setType] = React.useState(getLinkType(value));

	const handleInputChange = ({ target: { value } }) => {
		setInputValue(value);
		setIsError(!!value && !isValidValue(value, totalPages)[type]);
	};

	const handleButtonAddClick = () => {
		onChange(inputValue);
	};

	const handleButtonRemoveClick = () => {
		setInputValue('');
		setIsError(false);

		if (value) {
			onChange('');
		}
	};

	const handleTypeChange = (type: LinkType) => {
		setType(type);
		const initialValue = type === getLinkType(value) ? value : '';
		setInputValue(initialValue);
		setIsError(false);
	};

	React.useEffect(() => {
		// update state when value from props was changed (when switch between links)
		setInputValue(value);
		setType(getLinkType(value));
		setIsError(!!value && !isValidValue(value, totalPages)[getLinkType(value)]);
	}, [value]);

	const placeholder = type === LinkType.url
		? 'https://yourlink.com'
		: I18n.t('messages.page');

	return (
		<>
			<InputWrapper
				hasButtonAdd={true}
				hasButtonRemove={true}
				isError={isError}
			>
				{isError && <Error value={errorMessages[type]} />}
				<IconLink>
					{Utils.getSvgIcon('iconset_uprez_link')}
				</IconLink>
				<input
					type="text"
					value={inputValue}
					placeholder={placeholder}
					disabled={!value && !canAddLink}
					onChange={handleInputChange}
					onFocus={onFocus}
					onBlur={onBlur}
				/>
				<ButtonAdd
					type="button"
					disabled={!inputValue || isError}
					onClick={handleButtonAddClick}
				>
					{Utils.getSvgIcon('iconset_uprez_check')}
				</ButtonAdd>
				<ButtonRemove onClick={handleButtonRemoveClick} />
			</InputWrapper>
			{!isUrlLinkOnly &&
				<LinkTypeToggle
					type={type}
					onChange={handleTypeChange}
				/>
			}
		</>
	);
};

export default LinkPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/LinkPanel/index.tsx